import React, { useState } from 'react'

import Pl from '../i/img_placeholder.svg'
import EditBlockButton from './Controls/EditBlockButton'
import { PuzzlePlaygroundPreview } from './Modals/PuzzleModal/components'
import StatisticPreview from './Components/StatisticPreview'
import { PuzzleModal } from './Modals/PuzzleModal'

/**
 * PuzzleBlock
 */

const PuzzleBlock = ({ struct, enableTimer, methods, onUpdate, id, colorTheme }) => {
    const [isModalActive, setModalActive] = useState(false)

    const openModal = evt => {
        evt.preventDefault()
        setModalActive(true)
    }

    const closeModal = () => {
        setModalActive(false)
    }

    return (
        <div className="puzzle-block-horizontal">
            <EditBlockButton onClick={openModal} />
            {enableTimer && <StatisticPreview actionsTitle="Number of moves" />}
            <PuzzlePlaygroundPreview
                colorTheme={colorTheme}
                image={struct.playground ? struct.playground.image : Pl}
                layout={struct.playground ? struct.playground.layout : { value: 4 }}
                isShowCover={struct.playground ? struct.playground.isShowCover : false}
                coverHeader={struct.playground ? struct.playground.coverHeader : null}
                coverButtonText={struct.playground ? struct.playground.coverButtonText : null}
                height={400}
                isModal={false}
            />
            {isModalActive && (
                <PuzzleModal
                    data={{
                        structure: struct,
                        colorTheme,
                        id,
                    }}
                    methods={{
                        openAssetManager: methods.openAssetManager,
                        closeModal: closeModal,
                        save: onUpdate,
                    }}
                />
            )}
        </div>
    )
}

export default PuzzleBlock
